module.exports = __webpack_public_path__ + "static/img/icon_bcj.dc844a81.png";